import React from 'react'

export default function SklListJustSearch() {
    return (
        <div role="status" className="w-full animate-pulse divide-y divide-gray-200 rounded border border-gray-200 p-2 shadow ">
            <div className="h-fit min-h-[40px] flex flex-col gap-y-1 px-3 py-3">
                <div className="w-full h-5 rounded-lg bg-gray-300"></div>
                <div className="w-full h-3 rounded-lg bg-gray-300"></div>
            </div>
            <div className="h-fit min-h-[40px] flex flex-col gap-y-1 px-3 py-3">
                <div className="w-full h-5 rounded-lg bg-gray-300"></div>
                <div className="w-full h-3 rounded-lg bg-gray-300"></div>
            </div>
            <div className="h-fit min-h-[40px] flex flex-col gap-y-1 px-3 py-3">
                <div className="w-full h-5 rounded-lg bg-gray-300"></div>
                <div className="w-full h-3 rounded-lg bg-gray-300"></div>
            </div>
            <div className="h-fit min-h-[40px] flex flex-col gap-y-1 px-3 py-3">
                <div className="w-full h-5 rounded-lg bg-gray-300"></div>
                <div className="w-full h-3 rounded-lg bg-gray-300"></div>
            </div>
            <div className="h-fit min-h-[40px] flex flex-col gap-y-1 px-3 py-3">
                <div className="w-full h-5 rounded-lg bg-gray-300"></div>
                <div className="w-full h-3 rounded-lg bg-gray-300"></div>
            </div>
            <span className="sr-only">Loading...</span>
        </div>

    )
}
